import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("Ciudad");
const crud = rpcCrudService<models.Ciudad, models.Ciudad>(controller);

export const DireccionCiudad = cacheResource({
    ...crud,
    /**Obtiene todas las entidades filtradas por la zona */

    query: async (): Promise<models.Estado[]> => await controller('Query', {},),
    queryByMunicipio: async (IdMunicipio:number): Promise<models.CiudadDTO[]> => await controller("queryByMunicipio",{ IdMunicipio }),
}, {
        queryByMunicipio: true,
        query: true,
        getMemo: true,
    }, {
        add: true,
        delete: true,
        update: true
    });



// WEBPACK FOOTER //
// ./app/resources/items/DireccionCiudad.tsx